// Material UI
import { makeStyles } from '@material-ui/core';

export default makeStyles({
  root: {
    height: 80,
    width: 80,
  },
});
